import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store';
import EditTracking from 'src/components/editor/EditTracking';

const RatingAnswerSurveyTracking_0201: FC = () => {
  const dispatch = useDispatch();

  const currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  const btnText = useSelector((state: RootState) => state.buttons.btnText);
  const tracking = useSelector((state: RootState) => state.trackings.tracking);

  const style = `
    .root_tracking {
      background: none;

      .close {
        width: 100%;
      }

      .center_wrapper {
        width: 100%;
      }
      .survey_wrapper,
      .survey_inner {
        flex-direction: column;
        align-items: end;
        gap: 10px;
      }

      .bottom button {
        background: none;
      }

      .tracking_center {
        display: flex;
        align-items: center;
        justify-content: end;
      }
    }
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }} />
      <div className="root_view root_view_0201 root_tracking">
        <div className="template">
          <div className="center_horizon close tracking_center">
            <EditTracking
              value={tracking?.close_0201?.[currentIndex]}
              type="close_0201"
            />
          </div>
          <div className="center_wrapper">
            <div className="logo" />
            <div className="title" />
            <div className="sub_title" />
            <div className="star_wrapper" />
            <div className="survey_wrapper">
              {btnText?.option_button_0201?.[currentIndex]?.map(
                (_, idx: number) => (
                  <div key={idx}>
                    <EditTracking
                      value={
                        tracking?.option_button_0201?.[currentIndex]?.[idx]
                      }
                      idx={idx}
                      type="option_button_0201"
                    />
                  </div>
                )
              )}
            </div>
          </div>
          <div className="center_horizon bottom">
            <button className="button tracking_center">
              <EditTracking
                value={tracking?.button_0201?.[currentIndex]}
                type="button_0201"
              />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default RatingAnswerSurveyTracking_0201;
